export type SavedSelection = { range?: Range } | null;

let saved: SavedSelection = null;

/**
 * Salva a seleção atual se estiver dentro do elemento especificado
 */
export function saveSelection(root: HTMLElement): void {
  const sel = window.getSelection();
  if (!sel || sel.rangeCount === 0) {
    saved = null;
    return;
  }
  
  const range = sel.getRangeAt(0);
  // Só salva se a seleção estiver dentro do editor
  if (root.contains(range.commonAncestorContainer)) {
    saved = { range: range.cloneRange() };
  } else {
    saved = null;
  }
}

/**
 * Restaura a seleção previamente salva
 */
export function restoreSelection(root: HTMLElement): boolean {
  if (!saved?.range) return false;
  
  try {
    const sel = window.getSelection();
    if (!sel) return false;
    
    sel.removeAllRanges();
    sel.addRange(saved.range);
    return true;
  } catch (error) {
    console.error('SelectionManager: Error restoring selection:', error);
    return false;
  }
}

/**
 * Previne perda de foco do contentEditable
 */
export function preventFocusLoss(e: React.MouseEvent): void {
  e.preventDefault();
}

/**
 * Executa uma operação preservando a seleção
 */
export function withSelectionPreservation<T>(
  root: HTMLElement,
  operation: () => T
): T {
  saveSelection(root);
  const result = operation();
  restoreSelection(root);
  return result;
}